import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Filter from './Filter';
import Feeds from './Feeds';
import FeedComments from './feed-comments';
import * as jsPDF from 'jspdf';
import * as html2canvas from 'html2canvas';
import ReactGA from 'react-ga';
import moment from 'moment';
import {
  AreaChart,
  BarChart,
  Button,
  Calender,
  ColumnChart,
  ContactUs,
  EmotionsChart,
  LineChart,
  Loader,
  NoTopic,
  PieChart,
  SentimentsChart,
  SourcesPercentColumnChart,
  SpiderChart,
  WordCloud,
  WorldMapChart,
  BubbleChart
} from '../../shared-components';
import FeedDetails from './feeds-detail-modal/Feeds-Detail-Modal';
import DropdownSelection from './feeds-detail-modal/DropdownSelection';
import AddChartModal from './AddChartModal';
import ShareReportModal from './ShareReportModal';
import { Link } from 'react-router-dom';
import qs from 'qs';
import TweetsTab from './TweetsTab';
import UploadedCommentsTab from './UploadedCommentsTab';
import HeadlinesTab from './HeadlinesTab';
import CommentFilter from './CommentFilter';
import {
  ALL,
  ANGER,
  COMMENT_SORT_OPTIONS,
  COMMENT_SORT_OPTION_DISPLAY_NAMES_BY_API_VALUE,
  COMMENT_VIEW_SHORTCUT_ICON_CLASSES_BY_ARTICLE_TYPE,
  COMMENT_VIEW_SHORTCUT_ICON_TOOLTIP_TEXT_BY_ARTICLE_TYPE,
  DEFAULT_COMMENT_SORT_TYPE_VALUE,
  DEFAULT_POST_SORT_TYPE_VALUE,
  FEAR,
  GROUP_BY_EMOTION_STATE,
  GROUP_BY_SENTIMENT_STATE,
  JOY,
  LOCAL_STORAGE_KEY_FOR_HAS_ACCEPTED_FB_DATA_COMPLIANCE_AGREEMENT,
  MAXIMUM_DECIMAL_PLACES_FOR_SARCASM_SCORE,
  NEGATIVE,
  NEUTRAL,
  POST_SORT_OPTIONS,
  POST_SORT_OPTION_DISPLAY_NAMES_BY_API_VALUE,
  POSITIVE,
  SADNESS,
  SENTIMENT_VALUE_TO_PASS_TO_BACKEND_WHEN_COMMENT_FILTERING_BY_DISPLAY_NAME,
  SORT_BY_BUTTON_LABEL,
  SORT_BY_DATE_NEW_TO_OLD_STATE,
  COMMENT_SORT_STATE_TO_VALUE_MAP,
  SOURCE_NAME_ALL_NEWS,
  SOURCE_NAME_ALL_SOCIAL_MEDIA,
  SOURCE_NAME_TWITTER,
  SOURCE_TYPE_NEWS,
  TAB_NAME_COMMENTS,
  TAB_NAME_FEEDS,
  TAB_NAME_HEADLINES,
  TAB_NAME_TWEETS,
  CANCEL_BUTTON_COLOR,
  CONFIRM_BUTTON_COLOR,
  SARCASM_THRESHOLD_DISPLAY_MESSAGE_PARTS,
  CRAWLED_DATA_SOURCE_KEY,
  UPLOADED_DATA_SOURCE_KEY,
  FADE_IN_CLASS_NAME,
  FADE_OUT_CLASS_NAME,
  CSV_ARTICLE_TYPE_UPLOADED_COMMENTS,
  CSV_ARTICLE_TYPE_BY_ARTICLE_TYPE
} from '../redux/constants';
import { IS_SARCASM_ENABLED, SARCASM_THRESHOLD, apiEndPoints } from '../../../common/globalConstants';
import { DEFAULT_SARCASM_THRESHOLD } from '../../../common/globalUtils';
import 'react-dropdown/style.css';
import config from '../../../common/environmentConfig';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { t } from 'i18next';
import {
  DASHBOARD_I18N_PREFIX as MY_I18N_PREFIX,
  DASHBOARD_I18N_KEYS as MY_I18N_KEYS
} from './constants/i18n/Dashboardi18nConstants';
import { DATA_KEY } from '../../shared-components/chart/constants/eventLabellingChartConstants';

const MySweetAlertGenerator = withReactContent(Swal);

const Filters = [
  { value: 'all', name: 'all', checked: true },
  {
    value: SENTIMENT_VALUE_TO_PASS_TO_BACKEND_WHEN_COMMENT_FILTERING_BY_DISPLAY_NAME[POSITIVE],
    name: POSITIVE,
    checked: true
  },
  {
    value: SENTIMENT_VALUE_TO_PASS_TO_BACKEND_WHEN_COMMENT_FILTERING_BY_DISPLAY_NAME[NEGATIVE],
    name: NEGATIVE,
    checked: true
  },
  {
    value: SENTIMENT_VALUE_TO_PASS_TO_BACKEND_WHEN_COMMENT_FILTERING_BY_DISPLAY_NAME[NEUTRAL],
    name: NEUTRAL,
    checked: true
  },
  {
    value: SENTIMENT_VALUE_TO_PASS_TO_BACKEND_WHEN_COMMENT_FILTERING_BY_DISPLAY_NAME[JOY],
    name: JOY,
    checked: true
  },
  {
    value: SENTIMENT_VALUE_TO_PASS_TO_BACKEND_WHEN_COMMENT_FILTERING_BY_DISPLAY_NAME[ANGER],
    name: ANGER,
    checked: true
  },
  {
    value: SENTIMENT_VALUE_TO_PASS_TO_BACKEND_WHEN_COMMENT_FILTERING_BY_DISPLAY_NAME[FEAR],
    name: FEAR,
    checked: true
  },
  {
    value: SENTIMENT_VALUE_TO_PASS_TO_BACKEND_WHEN_COMMENT_FILTERING_BY_DISPLAY_NAME[SADNESS],
    name: SADNESS,
    checked: true
  },
];
const feedModalItemCount = 10;

class Dashboard extends Component {
  static propTypes = {
    cookies: PropTypes.object.isRequired,
    topicId: PropTypes.string.isRequired,
    updateDashboardCommentSortType: PropTypes.func.isRequired,
    loadMoreUploadedComments: PropTypes.func.isRequired,
    updateCrawledCommentsIsSarcasmManuallyToggled: PropTypes.func.isRequired,
    updateUploadedCommentsRelevant: PropTypes.func.isRequired,
    updateDashboardUploadedCommentSortType: PropTypes.func.isRequired,
    updateUploadedCommentsIsSarcasmManuallyToggled: PropTypes.func.isRequired
  };
  
  constructor(props) {
    super(props);
    this.state = {
      activeDataSource: CRAWLED_DATA_SOURCE_KEY,
      activeFeed: TAB_NAME_FEEDS,
      FilterItems: JSON.parse(JSON.stringify(Filters)),
      isLoader: false,
      isFeedModal: false,
      selectedFeedIndex: null,
      activeFeedCategory: ALL,
      groupFeedModalCommentsBy: GROUP_BY_SENTIMENT_STATE,
      sortFeedModalCommentsBy: SORT_BY_DATE_NEW_TO_OLD_STATE,
      feedModalMinimumSarcasmScore: 0,
      feedModalMaximumSarcasmScore: 100,
      isAddChartActive: false,
      isCommentsActive: false,
      isShareModalActive: false,
      isCommentsLoading: false,
      isUploadedCommentsLoading: false,
      isTweetsLoading: false,
      isHeadlinesLoading: false,
      isInitialLoadOfCommentsForThisTopic: false,
      isInitialLoadOfUploadedCommentsForThisTopic: false,
      isInitialLoadOfTweetsForThisTopic: false,
      isInitialLoadOfHeadlinesForThisTopic: false,
      showTweetsTabShortcutButton: false,
      showHeadlinesTabShortcutButton: false,
      isDownloadingCsv: false,
      sentimentsDate: "",
      dateRangeFilterValue: {
        fromDate: '',
        toDate: '',
      },
      filterValue: '',
      sourcesFilter: [],
      fullSourcesFilter: [],
      isSendReport: false,
      reportMailinglist: [],
      isFilterInChart: false,
      isContactUs: false,
      feedMenu: [TAB_NAME_FEEDS,TAB_NAME_COMMENTS,TAB_NAME_TWEETS,TAB_NAME_HEADLINES],
      comments: {
        [DATA_KEY]: [],
        count: 0
      },
      uploadedComments: {
        [DATA_KEY]: [],
        count: 0
      },
      feeds: {
        [DATA_KEY]: [],
        count: 0
      },
      tweets: {
        [DATA_KEY]: [],
        count: 0
      },
      headlines: {
        [DATA_KEY]: [],
        count: 0
      },
      postSortType: DEFAULT_POST_SORT_TYPE_VALUE,
      dashboardCommentSortType: DEFAULT_COMMENT_SORT_TYPE_VALUE,
      dashboardUploadedCommentsSortType: DEFAULT_COMMENT_SORT_TYPE_VALUE,
      dashboardTweetSortType: DEFAULT_COMMENT_SORT_TYPE_VALUE,
      topicKeywordsJSON: {}
    };

    this.chartContainer = React.createRef();
  }

  getI18nText(textKey) {
    return t(MY_I18N_PREFIX + "." + textKey);
  }

  setCommentsRelevant = commentId => {
    const { updateCommentsRelevant } = this.props;
    updateCommentsRelevant(commentId);
  };

  setUploadedCommentsRelevant = commentId => {
    const { updateUploadedCommentsRelevant } = this.props;
    updateUploadedCommentsRelevant(commentId);
  };

  setFeedsRelevant = props => {
    const { updateFeedsRelevant } = this.props;
    const {
      feedModalMinimumSarcasmScore,
      feedModalMaximumSarcasmScore
    } = this.state;
    const minimumSarcasmScoreDecimal = this._parseSarcasmScorePercentageToDecimal(feedModalMinimumSarcasmScore);
    const maximumSarcasmScoreDecimal = this._parseSarcasmScorePercentageToDecimal(feedModalMaximumSarcasmScore);
    props.feedModalMinimumSarcasmScore = minimumSarcasmScoreDecimal;
    props.feedModalMaximumSarcasmScore = maximumSarcasmScoreDecimal;
    updateFeedsRelevant(props);
  };
  showContactUs = () => {
    this.setState(prevState => {
      return {
        isContactUs: !prevState.isContactUs,
      };
    });
  };
  handleCommentView = type => {
    ReactGA.event(
      {
        category : type ,
        action : `user with id  ${this.props.cookies.cookies.userMeta} is viewing the ${type} `
      }
    )



    this.setState(prevState => {
      return {
        activeFeed: type,
        isCommentsActive: !prevState.isCommentsActive,
      };
    });
  };

  updateAvailableChart = e => {
    ReactGA.event(
      {
        category : 'Chart' ,
        action : `user with user id ${this.props.cookies.cookies.userMeta} added a chart ${JSON.stringify(e)}`
      }
    )
    this.props.updateSelectedCharts(e);
    this.setState({ isAddChartActive: false });
  };

  filterBySource = source => {
    if (source.length) {
      this.props.filter({ value: source, key: 'sources', sources: source });
      this.setState({ sourcesFilter: source }, () => {
        let filter = localStorage.getItem('dashboardFilter');
        filter =
          filter && filter.length
            ? { ...JSON.parse(filter), ...{ source: this.state.sourcesFilter } }
            : { source: this.state.sourcesFilter };
        localStorage.setItem('dashboardFilter', JSON.stringify(filter));
        ReactGA.event(
          {
            category : 'Sources_Filter' ,
            action : `user with id ${this.props.cookies.cookies.userMeta} filtered sources in dashboard by ${JSON.stringify(filter)}`
          }
        )
      });
    } else {
      let filter = localStorage.getItem('dashboardFilter');
      if (filter) {
        filter = JSON.parse(filter);
        if (filter.source) {
          delete filter.source;
        }
        localStorage.setItem('dashboardFilter', JSON.stringify(filter));
      }
    }
  };

  _hideTabsForUnselectedSources() {
    const isSelectedOnSourceTab              = this._getWhichSourcesForDashboardTabsAreSelectedOnSourcesTab();
    const isSelectedOnDashboardSourcesFilter = this._getWhichSourcesForDashboardTabsAreSelectedInDashboardSourcesFilter(isSelectedOnSourceTab);

    let showTwitter   = false;
    let showHeadlines = false;
    if (isSelectedOnSourceTab[TAB_NAME_TWEETS] && isSelectedOnDashboardSourcesFilter[TAB_NAME_TWEETS]) {
      showTwitter = true;
    }
    if (isSelectedOnSourceTab[TAB_NAME_HEADLINES] && isSelectedOnDashboardSourcesFilter[TAB_NAME_HEADLINES]) {
      showHeadlines = true;
    }

    if (showTwitter && showHeadlines) {
      this.setState({
        feedMenu: [TAB_NAME_FEEDS,TAB_NAME_COMMENTS,TAB_NAME_TWEETS,TAB_NAME_HEADLINES],
        showTweetsTabShortcutButton: true,
        showHeadlinesTabShortcutButton: true
      });
    }
    else if (showTwitter) {
      this.setState({
        feedMenu: [TAB_NAME_FEEDS,TAB_NAME_COMMENTS,TAB_NAME_TWEETS],
        showTweetsTabShortcutButton: true,
        showHeadlinesTabShortcutButton: false
      });
    }
    else if (showHeadlines) {
      this.setState({
        feedMenu: [TAB_NAME_FEEDS,TAB_NAME_COMMENTS,TAB_NAME_HEADLINES],
        showTweetsTabShortcutButton: false,
        showHeadlinesTabShortcutButton: true
      });
    }
    else {
      this.setState({
        feedMenu: [TAB_NAME_FEEDS, TAB_NAME_COMMENTS],
        showTweetsTabShortcutButton: false,
        showHeadlinesTabShortcutButton: false
      });
    }
  }

  _getListOfNewsSources() {
    let news_sources = [];
    for (let i=0;i<this.state.fullSourcesFilter.length;i++) {
      let source = this.state.fullSourcesFilter[i];
      if (source['sourceType'] === SOURCE_TYPE_NEWS) {
        news_sources.push(source['sourceName'])
      }
    }
    return news_sources;
  }

  _getWhichSourcesForDashboardTabsAreSelectedOnSourcesTab() {
    let isSelectedOnSourceTab = {};
    isSelectedOnSourceTab[TAB_NAME_TWEETS]    = false;
    isSelectedOnSourceTab[TAB_NAME_HEADLINES] = false;
    for (let i=0;i<this.state.fullSourcesFilter.length;i++) {
      let source = this.state.fullSourcesFilter[i];
      if (source['sourceName'] === SOURCE_NAME_TWITTER && source['selected'] === true) {
        isSelectedOnSourceTab[TAB_NAME_TWEETS] = true;
      }
      if (source['sourceType'] === SOURCE_TYPE_NEWS && source['selected'] === true) {
        isSelectedOnSourceTab[TAB_NAME_HEADLINES] = true;
      }
    }
    return isSelectedOnSourceTab;
  }

  _getWhichSourcesForDashboardTabsAreSelectedInDashboardSourcesFilter(isSelectedOnSourceTab) {
    const news_sources                                     = this._getListOfNewsSources();
    let isSelectedOnDashboardSourcesFilter                 = {};
    isSelectedOnDashboardSourcesFilter[TAB_NAME_TWEETS]    = false;
    isSelectedOnDashboardSourcesFilter[TAB_NAME_HEADLINES] = false;
    if (isSelectedOnSourceTab[TAB_NAME_TWEETS]) {
      if (this.state.sourcesFilter.length == 0 || this.state.sourcesFilter.includes(SOURCE_NAME_ALL_SOCIAL_MEDIA)|| this.state.sourcesFilter.includes(SOURCE_NAME_TWITTER) ) {
        isSelectedOnDashboardSourcesFilter[TAB_NAME_TWEETS] = true;
      }
    }
    if (isSelectedOnSourceTab[TAB_NAME_HEADLINES]) {
      if (this.state.sourcesFilter.length == 0 || this.state.sourcesFilter.includes(SOURCE_NAME_ALL_NEWS) ) {
        isSelectedOnDashboardSourcesFilter[TAB_NAME_HEADLINES] = true;
      }
      for (let i=0;i<news_sources.length;i++) {
        let news_source = news_sources[i];
        if (this.state.sourcesFilter.includes(news_source)) {
          isSelectedOnDashboardSourcesFilter[TAB_NAME_HEADLINES] = true;
        }
      }
    }
    return isSelectedOnDashboardSourcesFilter;
  }

  updateDimensions = () => {
    if (window.innerWidth <= 1024) {
      this.setState({ isCommentsActive: false });
    }
  };

  componentDidMount() {
    const { cookies } = this.props;
    ReactGA.pageview('/dashboard/'+cookies.cookies.userMeta)
    window.addEventListener('resize', this.updateDimensions);
    this.setState({ isCommentsActive: false });
    const parsed = qs.parse(window.location.search,  { ignoreQueryPrefix: true });
    let filter = localStorage.getItem('dashboardFilter');
    this._setFullSourcesFilterToStateIfNewSourcesFilter(this.props);
    if (parsed.fromDate && parsed.toDate) {
      let queryFilter = {
        fromDate: parsed['fromDate'],
        toDate: parsed['toDate']
      };
      this.setDateRangeFilter(queryFilter);
    }
    else if (filter) {
      filter = JSON.parse(filter);
      if (filter.dateRangeFilterValue) {
        this.setState({
          dateRangeFilterValue: filter.dateRangeFilterValue,
        });
      }
    }
    else {
      const dateRangeFilterValue = {
        fromDate: moment()
          .subtract(6, 'days')
          .format('YYYY-MM-DD'),
        toDate: moment().format('YYYY-MM-DD'),
      };
      this.setState({dateRangeFilterValue: dateRangeFilterValue});
      this.setDateRangeFilter(dateRangeFilterValue);
    }

    this._loadFilterFromLocalStorageIntoState();
    this._setSourcesFilterToStateIfNewSourcesFilter(this.props);
    this._updateCommentRelatedStateIfNeeded(this.props);
    this._updateUploadedCommentRelatedStateIfNeeded(this.props);
    this._setFeedsToStateIfNewFeeds(this.props);
    this._setPostSortTypeToStateIfNewPostSortType(this.props);
    this._setDashboardCommentSortTypeToStateIfNewDashboardCommentSortType(this.props);
    this._setDashboardUploadedCommentSortTypeToStateIfNewDashboardUploadedCommentSortType(this.props);
    this._setDashboardTweetSortTypeToStateIfNewDashboardTweetSortType(this.props);
    this._seTopicKeywordsJSONToStateIfNewTopicKeywordsJSON(this.props);
    this._updateTweetRelatedStateIfNeeded(this.props);
    this._updateHeadlineRelatedStateIfNeeded(this.props);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  handleFeedDetails = (sentiment, index) => {
    const { sortFeedModalCommentsBy, feedModalMinimumSarcasmScore, feedModalMaximumSarcasmScore } = this.state;
    const minimumSarcasmScoreDecimal = this._parseSarcasmScorePercentageToDecimal(feedModalMinimumSarcasmScore);
    const maximumSarcasmScoreDecimal = this._parseSarcasmScorePercentageToDecimal(feedModalMaximumSarcasmScore);
    const sortTypeParameter = this.parseSortStateToSortTypeParameter(sortFeedModalCommentsBy);
    this.props.retrieveFeedDetails({
      sentiment,
      pageLimit: feedModalItemCount,
      pageId: 1,
      feedId: this.props.feeds.data[index].feedId,
      sortType: sortTypeParameter,
      minSarcasmScore: minimumSarcasmScoreDecimal,
      maxSarcasmScore: maximumSarcasmScoreDecimal
    });
    this.setState({
      isFeedModal: true,
      activeFeedCategory: sentiment,
      selectedFeedIndex: index,
      selectedFeedId: this.props.feeds.data[index].feedId,
      feedModalCurrentPage: 1
    });
    if (sentiment !== ALL){
      this.setState({
        groupFeedModalCommentsBy: GROUP_BY_SENTIMENT_STATE
      })
    }
  };
  
  retrieveSelectedSentimentFeedDetails = sentiment => {
    const { selectedFeedId, sortFeedModalCommentsBy, feedModalMinimumSarcasmScore, feedModalMaximumSarcasmScore } = this.state;
    const minimumSarcasmScoreDecimal = this._parseSarcasmScorePercentageToDecimal(feedModalMinimumSarcasmScore);
    const maximumSarcasmScoreDecimal = this._parseSarcasmScorePercentageToDecimal(feedModalMaximumSarcasmScore);
    const sortTypeParameter = this.parseSortStateToSortTypeParameter(sortFeedModalCommentsBy);
    const queryParams = {
      sentiment,
      pageLimit: feedModalItemCount,
      pageId: 1,
      feedId: selectedFeedId,
      sortType: sortTypeParameter,
      minSarcasmScore: minimumSarcasmScoreDecimal,
      maxSarcasmScore: maximumSarcasmScoreDecimal
    };
    this.setState(
      {
        activeFeedCategory: sentiment,
        feedModalCurrentPage: 1,
      },
      () => {
        this.props.retrieveFeedDetails(queryParams);
      },
    );
  };

  loadMoreFeedDetails = () => {
    const { feedModalCurrentPage, selectedFeedId, sortFeedModalCommentsBy, feedModalMinimumSarcasmScore, feedModalMaximumSarcasmScore } = this.state;
    const minimumSarcasmScoreDecimal = this._parseSarcasmScorePercentageToDecimal(feedModalMinimumSarcasmScore);
    const maximumSarcasmScoreDecimal = this._parseSarcasmScorePercentageToDecimal(feedModalMaximumSarcasmScore);
    const sortTypeParameter = this.parseSortStateToSortTypeParameter(sortFeedModalCommentsBy);
    const queryParams = {
      sentiment: this.state.activeFeedCategory,
      pageLimit: feedModalItemCount,
      pageId: Number(feedModalCurrentPage) + 1,
      feedId: selectedFeedId,
      sortType: sortTypeParameter,
      minSarcasmScore: minimumSarcasmScoreDecimal,
      maxSarcasmScore: maximumSarcasmScoreDecimal
    };
    this.setState(
      {
        feedModalCurrentPage: Number(feedModalCurrentPage) + 1,
      },
      () => {
        this.props.retrieveFeedDetails(queryParams);
      },
    );
  };

  handleCommentsSortByInFeedModalChange = sortBySelection => {
    const sortBySelectionValue = sortBySelection['value'];
    if (COMMENT_SORT_OPTIONS.includes(sortBySelectionValue)){
      const sortTypeParameter = this.parseSortStateToSortTypeParameter(sortBySelectionValue);
      const { selectedFeedId, activeFeedCategory, feedModalMinimumSarcasmScore, feedModalMaximumSarcasmScore } = this.state;
      const minimumSarcasmScoreDecimal = this._parseSarcasmScorePercentageToDecimal(feedModalMinimumSarcasmScore);
      const maximumSarcasmScoreDecimal = this._parseSarcasmScorePercentageToDecimal(feedModalMaximumSarcasmScore);
      const queryParams = {
        sentiment: activeFeedCategory,
        pageLimit: feedModalItemCount,
        pageId: 1,
        feedId: selectedFeedId,
        sortType: sortTypeParameter,
        minSarcasmScore: minimumSarcasmScoreDecimal,
        maxSarcasmScore: maximumSarcasmScoreDecimal
      };
      this.setState(
        {
          sortFeedModalCommentsBy: sortBySelectionValue,
          feedModalCurrentPage: 1
        },
        () => {
          this.props.retrieveFeedDetails(queryParams);
        },
      );
    }
  };

  retrieveFeedDetailsWithSarcasmScoreFilter = (minimumSarcasmScore, maximumSarcasmScore) => {
    const { activeFeedCategory, selectedFeedId, sortFeedModalCommentsBy } = this.state;
    const sortTypeParameter = this.parseSortStateToSortTypeParameter(sortFeedModalCommentsBy);
    const minimumSarcasmScoreDecimal = this._parseSarcasmScorePercentageToDecimal(minimumSarcasmScore);
    const maximumSarcasmScoreDecimal = this._parseSarcasmScorePercentageToDecimal(maximumSarcasmScore);

    const queryParams = {
      sentiment: activeFeedCategory,
      pageLimit: feedModalItemCount,
      pageId: 1,
      feedId: selectedFeedId,
      sortType: sortTypeParameter,
      minSarcasmScore: minimumSarcasmScoreDecimal,
      maxSarcasmScore: maximumSarcasmScoreDecimal
    };
    this.setState(
      {
        feedModalCurrentPage: 1,
        feedModalMinimumSarcasmScore: minimumSarcasmScore,
        feedModalMaximumSarcasmScore: maximumSarcasmScore
      },
      () => {
        this.props.retrieveFeedDetails(queryParams);
      },
    );
  };

  parseSortStateToSortTypeParameter = sortType => {
    const sortTypeParameter = COMMENT_SORT_STATE_TO_VALUE_MAP[sortType];
    return sortTypeParameter;
  };

  handleFilter = event => {
    const { FilterItems } = this.state;
    const value = event.target.value;

    const updatedFilter = FilterItems.map(filterItem => {
      if (value === 'all') {

          if (event.target.checked)
         {
          ReactGA.event(
            {
              category : 'Filter' ,
              action : 'User with id' + this.props.cookies.cookies.userMeta+' filtered  according to all filters'
            }
          )
         }
         else
         {
          ReactGA.event(
            {
              category : 'Filter' ,
              action : 'User with id ' + this.props.cookies.cookies.userMeta+' removed the '+value+' filter'
            }
          )
         }


        return {
          ...filterItem,
          checked: event.target.checked,
        };
      }

      if (filterItem.value === value) {
        if (event.target.checked)
        {
         ReactGA.event(
           {
             category : 'Filter' ,
             action : 'User with id ' + this.props.cookies.cookies.userMeta+' filtered  according to '+value
           }
         )
        }
        else
        {
         ReactGA.event(
           {
             category : 'Filter' ,
             action : 'User with id ' + this.props.cookies.cookies.userMeta+' removed the '+value+' filter'
           }
         )
        }
        return {
          ...filterItem,
          checked: !filterItem.checked,
        };
       }


      return filterItem;

    });

    const updatedFilterCheckStatus = this._adjustEmotionSentimentFilterBasedOnLinkedSentimentsAndEmotions(updatedFilter, value)
    this.setState(
      {
        FilterItems: updatedFilterCheckStatus,
        isFilterInChart: false,
        sentimentsDate: ""
      },
      () => {
        let filter = '';
        if (value !== 'all') {
          filter = this.state.FilterItems.filter(item => item.checked);

          filter = filter.map(i => i.value);
        }
        this.props.filter({ value: filter, key: 'sentiments' });
        this._saveFilterFromStateIntoLocalStorage();
      },
    );
  };

  _adjustEmotionSentimentFilterBasedOnLinkedSentimentsAndEmotions(updatedFilter, value){
    const ALL_FILTER_INDEX = 0
    const JOY_FILTER_INDEX = 4
    const ANGER_FILTER_INDEX = 5
    const FEAR_FILTER_INDEX = 6
    const SADNESS_FILTER_INDEX = 7
    const POSITIVE_FILTER_INDEX = 1
    const NEGATIVE_FILTER_INDEX = 2

    if (value === JOY){
      updatedFilter[POSITIVE_FILTER_INDEX].checked = false
    } else if (value === ANGER || value === FEAR || value === SADNESS){
      updatedFilter[NEGATIVE_FILTER_INDEX].checked = false
    } else if (value === SENTIMENT_VALUE_TO_PASS_TO_BACKEND_WHEN_COMMENT_FILTERING_BY_DISPLAY_NAME[POSITIVE]){
      updatedFilter[JOY_FILTER_INDEX].checked = false
    } else if (value === SENTIMENT_VALUE_TO_PASS_TO_BACKEND_WHEN_COMMENT_FILTERING_BY_DISPLAY_NAME[NEGATIVE]){
      updatedFilter[ANGER_FILTER_INDEX].checked = false
      updatedFilter[FEAR_FILTER_INDEX].checked = false
      updatedFilter[SADNESS_FILTER_INDEX].checked = false
    }

    const selectedItems = updatedFilter.filter(item => item.checked)
    const positiveSelected = selectedItems.filter(filter => filter.name === POSITIVE)
    const negativeSelected = selectedItems.filter(filter => filter.name === NEGATIVE)
    const joySelected = selectedItems.filter(filter => filter.name === JOY)
    const NegativeEmotionsSelected = selectedItems.filter(filter => filter.name === ANGER || filter.name === FEAR || filter.name === SADNESS)

    if (positiveSelected.length === 1 || joySelected.length === 1){
      updatedFilter[POSITIVE_FILTER_INDEX].checked = true
      updatedFilter[JOY_FILTER_INDEX].checked = true
    }

    const TOTAL_POSSIBLE_NEGATIVE_EMOTIONS_IN_FILTER = 3
    if (negativeSelected.length ===1 || NegativeEmotionsSelected.length === TOTAL_POSSIBLE_NEGATIVE_EMOTIONS_IN_FILTER){
      updatedFilter[NEGATIVE_FILTER_INDEX].checked = true
      updatedFilter[ANGER_FILTER_INDEX].checked = true
      updatedFilter[FEAR_FILTER_INDEX].checked = true
      updatedFilter[SADNESS_FILTER_INDEX].checked = true
    }

    const selectedItemsWithoutAll = updatedFilter.filter(filter => filter.checked && filter.value !== 'all')
    const TOTAL_POSSIBLE_ITEMS_IN_FILTER_WITHOUT_ALL = 7
    if (selectedItemsWithoutAll.length === TOTAL_POSSIBLE_ITEMS_IN_FILTER_WITHOUT_ALL) {
      updatedFilter[ALL_FILTER_INDEX].checked = true
    } else {
      updatedFilter[ALL_FILTER_INDEX].checked = false
    }

    return updatedFilter
  }

  _saveFilterFromStateIntoLocalStorage() {
    let dashboardFilter = JSON.parse(localStorage.getItem('dashboardFilter'));
    if (! dashboardFilter) {
      dashboardFilter = {};
    }
    dashboardFilter.FilterItems = this.state.FilterItems;
    localStorage.setItem('dashboardFilter',JSON.stringify(dashboardFilter));
  }

  _loadFilterFromLocalStorageIntoState() {
    let dashboardFilter = JSON.parse(localStorage.getItem('dashboardFilter'));
    if (dashboardFilter && dashboardFilter.FilterItems) {
      this.setState({FilterItems: dashboardFilter.FilterItems});
    }
  }

  loadMoreAction = () => {
    this.setState({ isLoader: true }, () => {
      setTimeout(() => {
        this.setState({ isLoader: false });
      }, 2000);
    });
  };

  resetChartFilter = () => {
    ReactGA.event(
      {
        category : 'Chart' ,
        action : `user with user id ${this.props.cookies.userMeta} has reset his chart filter`
      }
    )
    this.setState(
      {
        isFilterInChart: false,
        sentimentsDate: "",
        FilterItems: JSON.parse(JSON.stringify(Filters))
      },
      () => {
        this.props.resetFilterInChart();
      },
    );
  };

  filterBySentimentsFromChart = e => {

    this.setState({
      isFilterInChart: true,
      sentimentsDate: e.dateTime,
    },()=>{
      console.log("'Dashboard state", this.state)
      console.log("'Dashboard sentiments", e)
    });
    ReactGA.event(
      {
        category : 'Chart' ,
        action : `user with user id ${this.props.cookies.userMeta} filtered his charts by ${e.sentiment}`
      }
    )
    this.props.filter({ value: e.sentiment, key: 'sentiments', date: e.dateTime });
    console.log("'dashboard props", this.props)
  };

  exportToPdf = () => {
    const el = this.chartContainer.current;
    const HTML_Width = el.offsetWidth;
    const HTML_Height = el.offsetHeight;
    const top_left_margin = 30;
    const PDF_Width = HTML_Width + top_left_margin * 2;
    const PDF_Height = HTML_Height + top_left_margin * 2 ;
    const canvas_image_width = HTML_Width;
    const canvas_image_height = HTML_Height;
    const totalPDFPages = Math.ceil(HTML_Height / PDF_Height) - 1;
    const currentDate = moment().format('MM-DD-YYYY');

    let topicName = this.props.headerTopicData.topicName || 'NO_TOPIC';
    ReactGA.event(
      {
        category : 'User' ,
        action : `User with id ${this.props.cookies.cookies.userMeta} downloaded the report for ${topicName} on ${currentDate}  as a pdf file `
      }
    )
    html2canvas(el, {
      allowTaint: true,
      removeContainer: false,
    }).then(function(canvas) {
      canvas.getContext('2d');

      var imgData = canvas.toDataURL('image/png', 1);
      var pdf = new jsPDF('', 'pt', [PDF_Height, PDF_Width]);
      pdf.setTextColor(102, 102, 102);
      pdf.setFillColor(247, 247, 247, 1);
      pdf.setFontSize(12);
      pdf.text(top_left_margin, 25, `Topic: ${topicName}`);
      pdf.text(canvas_image_width - 130, 25, `Downloaded on: ${currentDate}`);
      pdf.addImage(
        imgData,
        'JPG',
        top_left_margin,
        top_left_margin,
        canvas_image_width,
        canvas_image_height,
      );

      for (var i = 1; i <= totalPDFPages; i++) {
        pdf.addPage(PDF_Width, PDF_Height);
        pdf.addImage(
          imgData,
          'JPG',
          top_left_margin,
          -(PDF_Height * i) + top_left_margin,
          canvas_image_width,
          canvas_image_height,
        );
      }

      pdf.save(`${topicName}_${currentDate}_report.pdf`);
    });
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!nextProps.isShareReportSending) {
      this.setState({ isSendReport: false, isShareModalActive: false });
    }

    this._setSentimentssFilterToStateIfNewSentiments(nextProps);
    this._setFullSourcesFilterToStateIfNewSourcesFilter(nextProps);
    this._setSourcesFilterToStateIfNewSourcesFilter(nextProps);
    this._updateCommentRelatedStateIfNeeded(nextProps);
    this._updateUploadedCommentRelatedStateIfNeeded(nextProps);
    this._setFeedsToStateIfNewFeeds(nextProps);
    this._setPostSortTypeToStateIfNewPostSortType(nextProps);
    this._setDashboardCommentSortTypeToStateIfNewDashboardCommentSortType(this.props);
    this._setDashboardUploadedCommentSortTypeToStateIfNewDashboardUploadedCommentSortType(this.props);
    this._setDashboardTweetSortTypeToStateIfNewDashboardTweetSortType(this.props);
    this._seTopicKeywordsJSONToStateIfNewTopicKeywordsJSON(nextProps);
    this._updateTweetRelatedStateIfNeeded(nextProps);
    this._updateHeadlineRelatedStateIfNeeded(nextProps);
    this._updateIsDownloadingCsvIfNeeded(nextProps);
  }

  _setSentimentssFilterToStateIfNewSentiments(nextProps) {
    if(nextProps.sentiments !== this.props.sentiments && nextProps.sentiments !== ""){
      let FilterItems = JSON.parse(JSON.stringify(this.state.FilterItems))
      let found = FilterItems.filter(r=>nextProps.sentiments.findIndex(s => s === r.value) !== -1);
      if(found && found.length > 0){
        FilterItems.forEach(r => r.checked = false);
        found.forEach(r => r.checked = true);
        this.setState({FilterItems});
      }
    }
  }

  _setFullSourcesFilterToStateIfNewSourcesFilter(nextProps) {
    if (Object.keys(nextProps.sourcesFilter).length && JSON.stringify(this.state.fullSourcesFilter) !== JSON.stringify(nextProps.sourcesFilter)) {
        this.setState({fullSourcesFilter: nextProps.sourcesFilter}, () => {
          this._hideTabsForUnselectedSources();
        });
      }
  }

  _setSourcesFilterToStateIfNewSourcesFilter(nextProps) {
    if (
      Object.keys(nextProps.sources).length &&
      JSON.stringify(this.state.sourcesFilter) !== JSON.stringify(nextProps.sources)
    ) {
        this.setState({sourcesFilter: nextProps.sources}, () => {
          this._hideTabsForUnselectedSources();
        });
    }
  }

  _updateCommentRelatedStateIfNeeded(nextProps) {
    let updatedState = {};
    if (nextProps.isInitialLoadOfCommentsForThisTopic !== this.state.isInitialLoadOfCommentsForThisTopic) {
      if (nextProps.isInitialLoadOfCommentsForThisTopic) {
        updatedState['isFilterInChart'] = false;
        updatedState['sentimentsDate']  = "";
      }
      updatedState['isInitialLoadOfCommentsForThisTopic'] = nextProps.isInitialLoadOfCommentsForThisTopic;
    }
    if (nextProps.isCommentsLoading !== this.state.isCommentsLoading) {
      updatedState['isCommentsLoading'] = nextProps.isCommentsLoading;
    }
    if (this._newListOfCommentsReceivedFromProps(nextProps)) {
      updatedState['comments'] = nextProps.comments;
    }

    if (Object.keys(updatedState).length > 0) {
      this.setState(updatedState);
    }
  }

  _newListOfCommentsReceivedFromProps(nextProps) {
    let isNewListOfCommentsReceivedFromProps = false;
    if (Object.keys(nextProps.comments).length &&
        JSON.stringify(this.state.comments) !== JSON.stringify(nextProps.comments) &&
        Array.isArray(nextProps.comments.data)
    ) {
      isNewListOfCommentsReceivedFromProps = true;
    }
    return isNewListOfCommentsReceivedFromProps;
  }

  _updateUploadedCommentRelatedStateIfNeeded(nextProps) {
    let updatedState = {};
    if (nextProps.isInitialLoadOfUploadedCommentsForThisTopic !== this.state.isInitialLoadOfUploadedCommentsForThisTopic) {
      if (nextProps.isInitialLoadOfUploadedCommentsForThisTopic) {
        updatedState.isFilterInChart = false;
        updatedState.sentimentsDate  = "";
      }
      updatedState.isInitialLoadOfUploadedCommentsForThisTopic = nextProps.isInitialLoadOfUploadedCommentsForThisTopic;
    }
    if (nextProps.isUploadedCommentsLoading !== this.state.isUploadedCommentsLoading) {
      updatedState.isUploadedCommentsLoading = nextProps.isUploadedCommentsLoading;
    }
    if (this._newListOfUploadedCommentsReceivedFromProps(nextProps)) {
      updatedState.uploadedComments = nextProps.uploadedComments;
    }

    if (Object.keys(updatedState).length > 0) {
      this.setState(updatedState);
    }
  }

  _newListOfUploadedCommentsReceivedFromProps(nextProps) {
    let isNewListOfUploadedCommentsReceivedFromProps = false;
    if (Object.keys(nextProps.uploadedComments).length &&
        JSON.stringify(this.state.uploadedComments) !== JSON.stringify(nextProps.uploadedComments) &&
        Array.isArray(nextProps.uploadedComments.data)
    ) {
      isNewListOfUploadedCommentsReceivedFromProps = true;
    }
    return isNewListOfUploadedCommentsReceivedFromProps;
  }

  _updateTweetRelatedStateIfNeeded(nextProps) {
    let updatedState = {};
    if (nextProps.isInitialLoadOfTweetsForThisTopic !== this.state.isInitialLoadOfTweetsForThisTopic) {
      updatedState['isInitialLoadOfTweetsForThisTopic'] = nextProps.isInitialLoadOfTweetsForThisTopic;
    }
    if (nextProps.isTweetsLoading !== this.state.isTweetsLoading) {
      updatedState['isTweetsLoading'] = nextProps.isTweetsLoading;
    }
    if (this._newListOfTweetsReceivedFromProps(nextProps)) {
      updatedState['tweets'] = nextProps.tweets;
    }

    if (Object.keys(updatedState).length > 0) {
      this.setState(updatedState);
    }
  }

  _newListOfTweetsReceivedFromProps(nextProps) {
    let isNewListOfTweetsReceivedFromProps = false;
    if (
      Object.keys(nextProps.tweets).length &&
      JSON.stringify(this.state.tweets) !== JSON.stringify(nextProps.tweets) &&
      (Array.isArray(nextProps.tweets.data))
     ) {
        isNewListOfTweetsReceivedFromProps = true;
      }
      return isNewListOfTweetsReceivedFromProps;
  }

  _updateHeadlineRelatedStateIfNeeded(nextProps) {
    let updatedState = {};
    if (nextProps.isInitialLoadOfHeadlinesForThisTopic !== this.state.isInitialLoadOfHeadlinesForThisTopic) {
      updatedState['isInitialLoadOfHeadlinesForThisTopic'] = nextProps.isInitialLoadOfHeadlinesForThisTopic;
    }
    if (nextProps.isHeadlinesLoading !== this.state.isHeadlinesLoading) {
      updatedState['isHeadlinesLoading'] = nextProps.isHeadlinesLoading;
    }
    if (this._newListOfHeadlinesReceivedFromProps(nextProps)) {
      updatedState['headlines'] = nextProps.headlines;
    }

    if (Object.keys(updatedState).length > 0) {
      this.setState(updatedState);
    }
  }

  _newListOfHeadlinesReceivedFromProps(nextProps) {
    let isNewListOfHeadlinesReceivedFromProps = false;
    if (Object.keys(nextProps.headlines).length &&
        JSON.stringify(this.state.headlines) !== JSON.stringify(nextProps.headlines) &&
        Array.isArray(nextProps.headlines.data)
    ) {
      isNewListOfHeadlinesReceivedFromProps= true;
    }
    return isNewListOfHeadlinesReceivedFromProps;
  }

  _updateIsDownloadingCsvIfNeeded(nextProps) {
      if (nextProps.isDownloadingCsv !== this.state.isDownloadingCsv) {
          this.setState({
              isDownloadingCsv: nextProps.isDownloadingCsv
          });
      }

  }

  _setFeedsToStateIfNewFeeds(nextProps) {
    if (
      Object.keys(nextProps.feeds).length &&
      JSON.stringify(this.state.feeds) !== JSON.stringify(nextProps.feeds)
    ) {
      if (Array.isArray(nextProps.feeds.data)) {
        let feeds = {
          'count': nextProps.feeds.count,
          'data': []
        };
        let topicId = nextProps.topicId[0];
        for (let i=0;i<nextProps.feeds.data.length;i++) {
          let feed = nextProps.feeds.data[i];
          if (feed.topicId === topicId) {
            feeds.data.push(feed);
          }
        }
        this.setState({
          feeds: feeds,
        });
      }
    }
  }

  _setPostSortTypeToStateIfNewPostSortType(nextProps) {
    if (nextProps.postSortType && this.state.postSortType !== nextProps.postSortType) {
      this.setState({postSortType: nextProps.postSortType});
    }
  }

  _setDashboardCommentSortTypeToStateIfNewDashboardCommentSortType(nextProps) {
    if (nextProps.dashboardCommentSortType && this.state.dashboardCommentSortType !== nextProps.dashboardCommentSortType) {
      this.setState({dashboardCommentSortType: nextProps.dashboardCommentSortType});
    }
  }

  _setDashboardUploadedCommentSortTypeToStateIfNewDashboardUploadedCommentSortType(nextProps) {
    if (nextProps.dashboardUploadedCommentsSortType && this.state.dashboardUploadedCommentsSortType !== nextProps.dashboardUploadedCommentsSortType) {
      this.setState({dashboardUploadedCommentsSortType: nextProps.dashboardUploadedCommentsSortType});
    }
  }

  _setDashboardTweetSortTypeToStateIfNewDashboardTweetSortType(nextProps) {
    if (nextProps.dashboardTweetSortType && this.state.dashboardTweetSortType !== nextProps.dashboardTweetSortType) {
      this.setState({dashboardTweetSortType: nextProps.dashboardTweetSortType});
    }
  }

  _seTopicKeywordsJSONToStateIfNewTopicKeywordsJSON(nextProps) {
    if (nextProps.topicKeywordsJSON && this.state.topicKeywordsJSON !== nextProps.topicKeywordsJSON) {
      this.setState({topicKeywordsJSON: nextProps.topicKeywordsJSON});
    }
  }

  sendReportEmail = () => {
    let topicName   = this.props.headerTopicData.topicName || 'NO_TOPIC';
    const {topicId} = this.props;
    const {
      reportMailinglist,
      dateRangeFilterValue
    } = this.state;
    ReactGA.event(
      {
        category : 'User' ,
        action : `User with id ${this.props.cookies.cookies.userMeta} shared the report with ${reportMailinglist}`
      }
    )
    const formData = {
      email: reportMailinglist.join(','),
      topic_id: topicId[0],
      topic_name: topicName,
      from_date: dateRangeFilterValue.fromDate,
      to_date: dateRangeFilterValue.toDate
    };
    this.props.sendEmailReport(formData);
  };

  sendReport = emailList => {
    this.setState(
      {
        isSendReport: true,
        reportMailinglist: emailList,
      },
      () => {
        this.sendReportEmail();
      },
    );
  };

  setDateRangeFilter = e => {
    this.setState({
      dateRangeFilterValue: e,
      isFilterInChart: false,
      sentimentsDate: ""
    }, () => {
      let filter = localStorage.getItem('dashboardFilter');
      filter =
        filter && filter.length
          ? { ...JSON.parse(filter), ...{ dateRangeFilterValue: e } }
          : { dateRangeFilterValue: e };
      localStorage.setItem('dashboardFilter', JSON.stringify(filter));
    });
    this.props.filterFeedsCommentsByDate(e);
  };

  setShareReportModal = () => {
    this.setState({ isShareModalActive: true });
    this.props.retrieveShareReportMessage();
  };

  actionButtons = activeFeed => {
    ReactGA.event(
      {
        category : activeFeed ,
        action : activeFeed + ' csv data was downloaded by user with id '+this.props.cookies.cookies.userMeta
      }
    );

    if (this._hasAcceptedFBDataComplianceAgreementAlready()) {
      this._executeCSVDownloadSteps(activeFeed);
    }
    else {
      MySweetAlertGenerator.fire({
        title: 'Data Compliance Agreement',
        type: 'info',
        html: this.getI18nText(MY_I18N_KEYS.data_compliance_agreement),
        showCancelButton: true,
        confirmButtonColor: CONFIRM_BUTTON_COLOR,
        cancelButtonColor: CANCEL_BUTTON_COLOR,
        cancelButtonText: 'Decline',
        confirmButtonText: 'Accept'
      }).then((result) => {
        if (result.value === true) {
          this._setFBDataComplianceAgreementAsAccepted();
          this._executeCSVDownloadSteps(activeFeed);
        }
      })
    }
  }

  _executeCSVDownloadSteps(activeFeed) {
    this.setState({isDownloadingCsv: true}, () => {
      const url = this._buildCsvDownloadUrl(activeFeed);
      this._triggerStreamDownload(url);
      this._makeCSVButtonClickableAgainAfterFiveSeconds();
    });
  }

  _setFBDataComplianceAgreementAsAccepted() {
    localStorage.setItem(LOCAL_STORAGE_KEY_FOR_HAS_ACCEPTED_FB_DATA_COMPLIANCE_AGREEMENT,"true");
  }

  _hasAcceptedFBDataComplianceAgreementAlready() {
    return localStorage.getItem(LOCAL_STORAGE_KEY_FOR_HAS_ACCEPTED_FB_DATA_COMPLIANCE_AGREEMENT);
  }

  _buildCsvDownloadUrl = (activeFeed) => {
    const { dateRangeFilterValue } = this.state;
    const fromDate = dateRangeFilterValue && dateRangeFilterValue.fromDate;
    const toDate = dateRangeFilterValue && dateRangeFilterValue.toDate;

    const savedFilterData = JSON.parse(localStorage.getItem('dashboardFilter'));
    const sources =  (savedFilterData && savedFilterData.source)
      ? savedFilterData.source
      : 'all sources';

    const params = new URLSearchParams({
      fromDate: fromDate,
      toDate: toDate,
      topicId: this.props.topicId,
      sources,
      type:  CSV_ARTICLE_TYPE_BY_ARTICLE_TYPE[activeFeed],
    });

    const baseUrl = config[process.env.NODE_ENV].BASE_URL;
    return `${baseUrl}${apiEndPoints.csv.RETRIEVE_CSV}?${params.toString()}`;
  }

  _triggerStreamDownload = (url) => {
    const a = document.createElement('a');
    a.href = url;
    a.rel = 'noopener';
    a.target="_blank";
    a.download = '';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  _makeCSVButtonClickableAgainAfterFiveSeconds() {
    const FIVE_SECONDS_IN_MILLISECONDS = 5000;
    setTimeout(() => this.setState({isDownloadingCsv: false}), FIVE_SECONDS_IN_MILLISECONDS);
  }

  _handleCommentsGroupByInFeedModalChange = groupBySelection => {
    const groupBySelectionValue = groupBySelection['value'];
    if (groupBySelectionValue === GROUP_BY_SENTIMENT_STATE || groupBySelectionValue === GROUP_BY_EMOTION_STATE) {
      this.setState({groupFeedModalCommentsBy: groupBySelectionValue});
    }
  }

  _setFeedModalSarcasmScoreFilter = (minimumSarcasmScore, maximumSarcasmScore) => {
    if (minimumSarcasmScore === '') {
      minimumSarcasmScore = 0;
    }
    if (maximumSarcasmScore === '') {
      maximumSarcasmScore = 100;
    }
    this.retrieveFeedDetailsWithSarcasmScoreFilter(minimumSarcasmScore, maximumSarcasmScore);
  }

  _parseSarcasmScorePercentageToDecimal = (sarcasmScore) => {
    let sarcasmScoreDecimal = sarcasmScore / 100;
    return sarcasmScoreDecimal.toFixed(MAXIMUM_DECIMAL_PLACES_FOR_SARCASM_SCORE);
  }

  _returnPostSortOptions() {
    const { postSortType } = this.state;
    const selectedSortOption = POST_SORT_OPTION_DISPLAY_NAMES_BY_API_VALUE[postSortType];
    let dropdownOptions = POST_SORT_OPTIONS.slice();
    const indexOfSortOptionToRemove = dropdownOptions.indexOf(selectedSortOption);
    if (indexOfSortOptionToRemove > -1) {
      dropdownOptions.splice(indexOfSortOptionToRemove, 1);
    }
    return dropdownOptions;
  }

  _returnDashboardCommentSortOptions() {
    const { dashboardCommentSortType } = this.state;
    let dropdownOptions = this._returnRemainingCommentOrTweetSortDropdownOptionsBasedOnSortType(dashboardCommentSortType);
    return dropdownOptions;
  }

  _returnDashboardUploadedCommentSortOptions() {
    const { dashboardUploadedCommentsSortType } = this.state;
    let dropdownOptions = this._returnRemainingCommentOrTweetSortDropdownOptionsBasedOnSortType(dashboardUploadedCommentsSortType);
    return dropdownOptions;
  }

  _returnDashboardTweetSortOptions() {
    const { dashboardTweetSortType } = this.state;
    let dropdownOptions = this._returnRemainingCommentOrTweetSortDropdownOptionsBasedOnSortType(dashboardTweetSortType);
    return dropdownOptions;
  }

  _returnRemainingCommentOrTweetSortDropdownOptionsBasedOnSortType(sortType) {
    const selectedSortOption = COMMENT_SORT_OPTION_DISPLAY_NAMES_BY_API_VALUE[sortType];
    let dropdownOptions = COMMENT_SORT_OPTIONS.slice();
    const indexOfSortOptionToRemove = dropdownOptions.indexOf(selectedSortOption);
    if (indexOfSortOptionToRemove > -1) {
      dropdownOptions.splice(indexOfSortOptionToRemove, 1);
    }
    return dropdownOptions;
  }

  _checkIfSarcasmThresholdDisplayMessageShouldBeShown() {
    const { topicId } = this.props;
    return (topicId.length > 0 && 
      IS_SARCASM_ENABLED && 
      SARCASM_THRESHOLD !== DEFAULT_SARCASM_THRESHOLD);
  }

  _returnSarcasmThresholdDisplayMessage() {
    const sarcasmThresholdPercentage = this._convertSarcasmThresholdToWholeNumberPercentage()
    return (
      <p>
        <i className="las la-exclamation-circle icon" />
        {SARCASM_THRESHOLD_DISPLAY_MESSAGE_PARTS[0]}
        <b>{sarcasmThresholdPercentage}%</b>
        {SARCASM_THRESHOLD_DISPLAY_MESSAGE_PARTS[1]}
        <b>{sarcasmThresholdPercentage}%</b>
        {SARCASM_THRESHOLD_DISPLAY_MESSAGE_PARTS[2]}
      </p>
    );
  }

  _convertSarcasmThresholdToWholeNumberPercentage() {
    const sarcasmThresholdPercentage = SARCASM_THRESHOLD * 100;
    return Math.floor(sarcasmThresholdPercentage);
  }

  _returnCrawledDataTypeTabHeader(tabName) {
    let header = this.getI18nText(tabName);
    let count = this._returnCrawledDataTypeTabCount(tabName);
    header += " (" + count + ")";
    return header;
  }

  _returnCrawledDataTypeTabCount(tabName) {
    if (tabName === TAB_NAME_COMMENTS) {
      const { comments } = this.state;
      return (comments.count ? comments.count : 0);
    }
    else if (tabName === TAB_NAME_FEEDS) {
      const { feeds } = this.state;
      return (feeds.count ? feeds.count : 0);
    }
    else if (tabName === TAB_NAME_TWEETS) {
      const { tweets } = this.state;
      return (tweets.count ? tweets.count : 0);
    }
  }

  _returnCrawledDataTypeTabClass(tabName, index) {
    const { activeFeed } = this.state;
    let className = 'crawled-data-tab ';
    if (activeFeed === tabName) {
      className += 'active ';
    }
    if (index !== 0) {
      className += 'not-first-child';
    }
    return className;
  }

  _returnCrawledDataTabContainerClassName() {
    const { isCommentsActive, activeDataSource } = this.state;
    let className = 'crawled-data-tab-container ';
    if (!isCommentsActive) {
      className += 'hidden ';
    }
    if (activeDataSource === CRAWLED_DATA_SOURCE_KEY && isCommentsActive) {
      className += FADE_IN_CLASS_NAME;
    }
    else {
      className += FADE_OUT_CLASS_NAME;
    }
    return className;
  }

  _returnCrawledDataFeedActiveOrDisabledClassName(tabName) {
    const {
      activeDataSource,
      activeFeed
    } = this.state;
    if (activeDataSource === CRAWLED_DATA_SOURCE_KEY && tabName === activeFeed) {
      return FADE_IN_CLASS_NAME;
    }
    else {
      return FADE_OUT_CLASS_NAME;
    }
  }

  render() {

    const {
      isFeedModal,
      selectedFeedIndex,
      activeFeedCategory,
      groupFeedModalCommentsBy,
      sortFeedModalCommentsBy,
      feedModalMinimumSarcasmScore,
      feedModalMaximumSarcasmScore,
      isAddChartActive,
      isCommentsActive,
      activeFeed,
      isShareModalActive,
      dateRangeFilterValue,
      isFilterInChart,
      isContactUs,
      feeds,
      comments,
      uploadedComments,
      tweets,
      headlines,
      isCommentsLoading,
      isUploadedCommentsLoading,
      isTweetsLoading,
      isHeadlinesLoading,
      isInitialLoadOfCommentsForThisTopic,
      isInitialLoadOfUploadedCommentsForThisTopic,
      isInitialLoadOfTweetsForThisTopic,
      isInitialLoadOfHeadlinesForThisTopic,
      sentimentsDate,
      topicKeywordsJSON,
      postSortType,
      dashboardCommentSortType,
      dashboardUploadedCommentsSortType,
      dashboardTweetSortType,
      activeDataSource
    } = this.state;
    const {
      availableCharts,
      sourcesFilter,
      isFeedsLoading,
      topicId,
      updateSelectedCharts,
      isShareReportSending,
      retrieveFeedsBegin,
      feedDetails,
    } = this.props;

    const updatedSourcesFilter = JSON.parse(JSON.stringify(sourcesFilter)).map(source => {
      source.checked = true;
      return source;
    });
    const postSortOptions = this._returnPostSortOptions();
    const dashboardCommentSortOptions = this._returnDashboardCommentSortOptions();
    const dashboardUploadedCommentSortOptions = this._returnDashboardUploadedCommentSortOptions();
    const dashboardTweetSortOptions = this._returnDashboardTweetSortOptions();

    return (
      <div className="container-fluid">
        <div className="d-flex dashboard-container">
          <div className="home-analytics w-100">
            <div className="analytics-menu">
              {topicId.length > 0 && (
                <React.Fragment>
                  <p>{this.getI18nText(MY_I18N_KEYS.overview)}</p>
                  {availableCharts.length > 0 && (
                    <div className="menu-item">
                      {isFilterInChart && (
                        <Button
                          icon="refresh"
                          label="Reset"
                          onClick={() => this.resetChartFilter()}
                        />
                      )}
                      <Button
                        icon="envelope"
                        label="Share"
                        onClick={() => this.setState({ isShareModalActive: true })}
                      />
                      <Button icon="download" label="PDF" onClick={() => this.exportToPdf()} />
                      <Filter
                        sourcesFilter={updatedSourcesFilter}
                        filterBySource={e => this.filterBySource(e)}
                      />
                      <Calender setDateRange={e => this.setDateRangeFilter(e)} />
                    </div>
                  )}
                </React.Fragment>
              )}
            </div>
            {this._checkIfSarcasmThresholdDisplayMessageShouldBeShown() && (
              <div className="sarcasm-threshold-message">
                {this._returnSarcasmThresholdDisplayMessage()}
              </div>
            )}
            <div className="analytics-container" ref={this.chartContainer}>
              <div className= {`row chart-container ${this._checkIfSarcasmThresholdDisplayMessageShouldBeShown() ? '' : 'add-top-margin'}`}>
                {topicId && dateRangeFilterValue.fromDate && dateRangeFilterValue.toDate && topicId.length > 0 ? (
                  availableCharts.map(
                    charts =>
                      charts.status && (
                        <React.Fragment key={charts.chartId}>
                          <RenderAvailableChart
                            cookies={this.props.cookies}
                            chart={{ ...charts }}
                            selectedTopicId={topicId && topicId.length ? [...topicId] : []}
                            dateFilterValue={dateRangeFilterValue}
                            updateSelectedCharts={e => updateSelectedCharts(e)}
                            source={this.state.sourcesFilter}
                            filterBySentiments={e => this.filterBySentimentsFromChart(e)}
                            isCommentsActive={isCommentsActive}
                          />
                        </React.Fragment>
                      ),
                  )
                ) : (
                  <NoTopic
                    title="Almost There"
                    message="Add topics and analyse the sentiments and emotions here."
                    icons={['area-chart', 'pie-chart', 'bar-chart']}
                  >
                    <Link to="/dashboard/topics">
                      <button className="btn-add-topic">ADD TOPIC</button>
                    </Link>
                  </NoTopic>
                )}
                {topicId && topicId.length > 0 && availableCharts.length > 0 && (
                  <div
                    className="chart-content"
                    data-html2canvas-ignore="true"
                    onClick={() => this.setState({ isAddChartActive: true })}
                  >
                    <div className="add-chart-container">
                      <div className="add-char-inner">
                        <span>
                          <i className="la la-plus" />{this.getI18nText(MY_I18N_KEYS.add_chart)}
                        </span>
                      </div>
                    </div>
                  </div>
                )}
                {topicId && topicId.length > 0 && !availableCharts.length && (
                  <div className="no-feed-comment-data">
                    <NoTopic
                      title="Something’s Missing"
                      message="Please check your Topics and Sources configuration. Otherwise, contact us for assistance."
                      icons={['exclamation-circle']}
                    >
                      <button className="btn-no-data" onClick={() => this.showContactUs()}>
                        CONTACT US
                      </button>
                    </NoTopic>
                  </div>
                )}
              </div>
            </div>
            <div
              className={`toggle-button ${isCommentsActive ? 'active' : ''}`}
              onClick={() =>
                {
                  ReactGA.event(
                    {
                      category : this.state.activeFeed ,
                      action : 'User with id ' + this.props.cookies.cookies.userMeta+' is viewing '+this.state.activeFeed
                    }
                  )
                  this.setState(prevState => {
                  return { isCommentsActive: !prevState.isCommentsActive };

                }
                )}
              }
            >
              <i className={`la la-chevron-circle-${isCommentsActive ? 'right' : 'left'}`} />
            </div>
          </div>
          <div className={`home-feeds flex-shrink-1 ${isCommentsActive ? 'active' : ''}`}>
            <div className={`comments shrink-button ${isCommentsActive ? 'hidden' : 'active'}`}>

              <ul>
                {this.state.feedMenu.map((feedItem, index) => (
                  <li
                    onClick={() => this.handleCommentView(feedItem)}
                    key={index}
                    title={`${COMMENT_VIEW_SHORTCUT_ICON_TOOLTIP_TEXT_BY_ARTICLE_TYPE[feedItem]}`}
                  >
                    <i className={`la ${COMMENT_VIEW_SHORTCUT_ICON_CLASSES_BY_ARTICLE_TYPE[feedItem]}`} />
                  </li>
                ))}
              </ul>
            </div>
            <div className={`feeds-header ${!isCommentsActive ? 'hidden' : ''}`}>
              <div className='data-source-tab-container'>
                <button
                    className={`data-source-tab ${activeDataSource === CRAWLED_DATA_SOURCE_KEY ? 'active' : ''}`}
                    onClick={() => {
                      this.setState({activeDataSource: CRAWLED_DATA_SOURCE_KEY});
                    }}
                  >
                    <i className="las la-comments" />
                    {this.getI18nText(MY_I18N_KEYS.social_media_data)}
                  </button>  
                  <button
                    className={`data-source-tab ${activeDataSource === UPLOADED_DATA_SOURCE_KEY ? 'active' : ''}`}
                    onClick={() => {
                      this.setState({activeDataSource: UPLOADED_DATA_SOURCE_KEY});
                    }}
                  >
                    <i className="las la-cloud-upload-alt" />
                    {this.getI18nText(MY_I18N_KEYS.uploaded_data)}
                  </button>            
              </div>
              
              <div className="feeds-action">
                  <CommentFilter  
                    commentFilterItems={this.state.FilterItems}
                    handleCommentsFilter={this.handleFilter}
                    minimumSarcasmScore={this.props.commentsAndTweetsMinimumSarcasmScoreDisplayed}
                    maximumSarcasmScore={this.props.commentsAndTweetsMaximumSarcasmScoreDisplayed}
                    setCommentsAndTweetsSarcasmScoreFilter={this.props.setCommentsAndTweetsSarcasmScoreFilter}
                    relevanceFilterOption={this.props.relevanceFilterOption}
                    handleRelevanceFilterSelection={this.props.handleRelevanceFilterSelection}
                  />
              </div>
            </div>
            <div className={this._returnCrawledDataTabContainerClassName()}>
              
                {this.state.feedMenu.map((tabName, index) => (
                  <button
                    className={this._returnCrawledDataTypeTabClass(tabName, index)}
                      onClick={() =>{
                        ReactGA.event(
                          {
                            category : activeFeed,
                            action : 'User with id ' + this.props.cookies.cookies.userMeta+' is viewing '+activeFeed
                          }
                        )
                        this.setState({ activeFeed: tabName })}}
                      key={index}
                    >
                      {this._returnCrawledDataTypeTabHeader(tabName)}
                    </button>
                ))}               
              
            </div>
            <div className={`feeds-container  ${!isCommentsActive ? 'hidden' : ''}`}>
              <ul>

                <li className={this._returnCrawledDataFeedActiveOrDisabledClassName(TAB_NAME_FEEDS)}>
                  <div className={`feed-comments`}>
                    <div className='sort-button-dashboard-container'>
                      <DropdownSelection
                        selectedOption={POST_SORT_OPTION_DISPLAY_NAMES_BY_API_VALUE[postSortType]}
                        handleSelectionChange={this.props.updatePostSortType}
                        dropdownOptions={postSortOptions}
                        buttonLabel={SORT_BY_BUTTON_LABEL}
                      /> 
                      <Button
                        icon="download"
                        label="CSV"
                        isLoading={this.state.isDownloadingCsv}
                        inputClassName="btn-download"
                        onClick={() => this.actionButtons(activeFeed)}
                      />
                    </div>
                    {topicId && topicId.length > 0 ? (
                      <React.Fragment>
                        {retrieveFeedsBegin && <Loader />}

                        {feeds['data'].length > 0 &&
                        feeds['data'].map((feed, index) => (
                          <Feeds
                            feed={feed}
                            key={index}
                            cookies={this.props.cookies.cookies}
                            updateRelevanceFeed={e => this.setFeedsRelevant(e)}
                            handleFeedDetails={e => this.handleFeedDetails(e, index)}
                            topicKeywordsJSON={topicKeywordsJSON}
                            isTopicPreview={false}
                            isHarmWatchTab={false}
                          />
                        ))}
                        {!retrieveFeedsBegin && !feeds.data.length && (
                          <div className="no-feed-comment-data">
                            <NoTopic
                              title="No Articles available"
                              message="Please check your Topics and Sources configuration. Otherwise, contact us for assistance."
                              icons={['exclamation-circle']}
                            >
                              <button className="btn-no-data" onClick={() => this.showContactUs()}>
                                CONTACT US
                              </button>
                            </NoTopic>
                          </div>
                        )}
                      </React.Fragment>
                    ) : (
                      <NoTopic
                        title="It’s Empty"
                        message="Add topics and the related comments will appear here."
                        icons={['rss-square']}
                      >
                        <Link to="/dashboard/topics">
                          <button className="btn-add-topic">ADD TOPIC</button>
                        </Link>
                      </NoTopic>
                    )}
                    {feeds['count'] && feeds['count'] > feeds['data'].length && (
                      <button
                        type="button"
                        className={`btn btn-loadmore ${isFeedsLoading ? 'disabled' : ''}`}
                        onClick={() => this.props.loadMoreFeeds(sentimentsDate)}
                      >
                        {isFeedsLoading ? (
                          <React.Fragment>
                            <i className="la la-spinner la-spin" /> Loading
                          </React.Fragment>
                        ) : (
                          'LOAD MORE'
                        )}
                      </button>
                    )}
                  </div>
                </li>

                <li className={this._returnCrawledDataFeedActiveOrDisabledClassName(TAB_NAME_COMMENTS)}>
                  <div className={`feed-comments`}>
                    <div className='sort-button-dashboard-container'>
                        <DropdownSelection
                          selectedOption={COMMENT_SORT_OPTION_DISPLAY_NAMES_BY_API_VALUE[dashboardCommentSortType]}
                          handleSelectionChange={this.props.updateDashboardCommentSortType}
                          dropdownOptions={dashboardCommentSortOptions}
                          buttonLabel={SORT_BY_BUTTON_LABEL}
                        />
                        <Button
                          icon="download"
                          label="CSV"
                          isLoading={this.state.isDownloadingCsv}
                          inputClassName="btn-download"
                          onClick={() => this.actionButtons(activeFeed)}
                        /> 
                      </div>
                    {topicId && topicId.length > 0 ? (
                      <React.Fragment>
                        {isInitialLoadOfCommentsForThisTopic && <Loader />}
                        {!isInitialLoadOfCommentsForThisTopic && comments.data.length > 0 &&
                          comments.data.map((userComment, index) => (
                            <FeedComments
                              cookies={this.props.cookies.cookies}
                              userComment={userComment}
                              key={index}
                              isFeedModal={false}
                              updateRelevance={e => this.setCommentsRelevant(e)}
                              updateCrawledCommentsIsSarcasmManuallyToggled={this.props.updateCrawledCommentsIsSarcasmManuallyToggled}
                              isHarmWatchTab={false}
                            />
                          ))}
                        {!isCommentsLoading && !isInitialLoadOfCommentsForThisTopic && !comments.data.length && (
                          <div className="no-feed-comment-data">
                            <NoTopic
                              title="No Articles available"
                              message="Please check your Topics and Sources configuration. Otherwise, contact us for assistance."
                              icons={['exclamation-circle']}
                            >
                              <button className="btn-no-data" onClick={() => this.showContactUs()}>
                                CONTACT US
                              </button>
                            </NoTopic>
                          </div>
                        )}
                      </React.Fragment>
                    ) : (
                      <NoTopic
                        title="It’s Empty"
                        message="Add topics and the related comments will appear here."
                        icons={['comments']}
                      >
                        <Link to="/dashboard/topics">
                          <button className="btn-add-topic">ADD TOPIC</button>
                        </Link>
                      </NoTopic>
                    )}
                    {!isInitialLoadOfCommentsForThisTopic && comments['count'] > 0 && comments['count'] > comments['data'].length && (
                      <button
                        type="button"
                        className={`btn btn-loadmore ${isCommentsLoading ? 'disabled' : ''}`}
                        onClick={() => this.props.loadMoreComments(sentimentsDate)}
                      >
                        {isCommentsLoading ? (
                          <React.Fragment>
                            <i className="la la-spinner la-spin" /> Loading
                          </React.Fragment>
                        ) : (
                          'LOAD MORE'
                        )}
                      </button>
                    )}
                  </div>
                </li>

                <li className={this._returnCrawledDataFeedActiveOrDisabledClassName(TAB_NAME_TWEETS)}>
                    <div className='sort-button-dashboard-container'>
                      <DropdownSelection
                        selectedOption={COMMENT_SORT_OPTION_DISPLAY_NAMES_BY_API_VALUE[dashboardTweetSortType]}
                        handleSelectionChange={this.props.updateDashboardTweetSortType}
                        dropdownOptions={dashboardTweetSortOptions}
                        buttonLabel={SORT_BY_BUTTON_LABEL}
                      />
                      <Button
                        icon="download"
                        label="CSV"
                        isLoading={this.state.isDownloadingCsv}
                        inputClassName="btn-download"
                        onClick={() => this.actionButtons(activeFeed)}
                      />
                    </div>
                    <TweetsTab
                      tweets={tweets}
                      loadMoreTweets={() => this.props.loadMoreTweets(sentimentsDate)}
                      isTweetsLoading={isTweetsLoading}
                      cookies={this.props.cookies}
                      updateTweetsRelevant={this.props.updateTweetsRelevant}
                      updateTweetsIsSarcasmManuallyToggled={this.props.updateTweetsIsSarcasmManuallyToggled}
                      retrieveCategoriesBegin={this.props.retrieveCategoriesBegin}
                      isInitialLoadOfTweetsForThisTopic={isInitialLoadOfTweetsForThisTopic}
                      topicId={topicId}
                      topicKeywordsJSON={topicKeywordsJSON}
                    />
                </li>

                <li className={this._returnCrawledDataFeedActiveOrDisabledClassName(TAB_NAME_HEADLINES)}>
                    <HeadlinesTab
                      headlines={headlines}
                      loadMoreHeadlines={() => this.props.loadMoreHeadlines(sentimentsDate)}
                      isHeadlinesLoading={isHeadlinesLoading}
                      cookies={this.props.cookies}
                      updateHeadlinesRelevant={this.props.updateHeadlinesRelevant}
                      retrieveCategoriesBegin={this.props.retrieveCategoriesBegin}
                      isInitialLoadOfHeadlinesForThisTopic={isInitialLoadOfHeadlinesForThisTopic}
                      topicId={topicId}
                    />
                </li>

                <li className={activeDataSource === UPLOADED_DATA_SOURCE_KEY ? FADE_IN_CLASS_NAME : FADE_OUT_CLASS_NAME}>
                    <div className='uploaded-comments-count'>
                      <span>{this.getI18nText(MY_I18N_KEYS.total_data_points) + uploadedComments.count}</span>
                    </div>
                    <div className='sort-button-dashboard-container'>
                      <DropdownSelection
                        selectedOption={COMMENT_SORT_OPTION_DISPLAY_NAMES_BY_API_VALUE[dashboardUploadedCommentsSortType]}
                        handleSelectionChange={this.props.updateDashboardUploadedCommentSortType}
                        dropdownOptions={dashboardUploadedCommentSortOptions}
                        buttonLabel={SORT_BY_BUTTON_LABEL}
                      />
                      <Button
                        icon="download"
                        label="CSV"
                        isLoading={this.state.isDownloadingCsv}
                        inputClassName="btn-download"
                        onClick={() => this.actionButtons(CSV_ARTICLE_TYPE_UPLOADED_COMMENTS)}
                      />
                    </div>
                    <UploadedCommentsTab
                      uploadedComments={uploadedComments}
                      loadMoreUploadedComments={() => this.props.loadMoreUploadedComments(sentimentsDate)}
                      isUploadedCommentsLoading={isUploadedCommentsLoading}
                      cookies={this.props.cookies}
                      updateUploadedCommentRelevance={e => this.setUploadedCommentsRelevant(e)}
                      updateUploadedCommentsIsSarcasmManuallyToggled={this.props.updateUploadedCommentsIsSarcasmManuallyToggled}
                      isInitialLoadOfUploadedCommentsForThisTopic={isInitialLoadOfUploadedCommentsForThisTopic}
                      topicId={topicId}
                    />
                </li>

              </ul>
            </div>
          </div>
          {isFeedModal && (
            <FeedDetails
              show={isFeedModal}
              toggleFeedDetails={() => this.setState({ isFeedModal: false })}
              feed={feeds['data'] ? feeds['data'][selectedFeedIndex] : []}
              feedDetails={feedDetails}
              updateRelevanceFeed={e => this.setFeedsRelevant(e)}
              loadMoreFeedDetails={() => this.loadMoreFeedDetails()}
              activeFeedCategory={activeFeedCategory}
              retrieveSelectedSentimentFeedDetails={e => this.retrieveSelectedSentimentFeedDetails(e)}
              updateRelevance={e => this.setCommentsRelevant(e)}
              updateCrawledCommentsIsSarcasmManuallyToggled={this.props.updateCrawledCommentsIsSarcasmManuallyToggled}
              cookies={this.props.cookies.cookies}
              topicKeywordsJSON={topicKeywordsJSON}
              groupFeedModalCommentsBy={groupFeedModalCommentsBy}
              sortFeedModalCommentsBy={sortFeedModalCommentsBy}
              feedModalMinimumSarcasmScore={feedModalMinimumSarcasmScore}
              feedModalMaximumSarcasmScore={feedModalMaximumSarcasmScore}
              handleCommentsGroupByInFeedModalChange={e => this._handleCommentsGroupByInFeedModalChange(e)}
              handleCommentsSortByInFeedModalChange={e => this.handleCommentsSortByInFeedModalChange(e)}
              setFeedModalSarcasmScoreFilter={(e,f) => this._setFeedModalSarcasmScoreFilter(e,f)}
              isHarmWatchTab={false}
            />
          )}
        </div>
        {isAddChartActive && (
          <AddChartModal
            cookies={this.props.cookies.cookies}
            isAddChartActive={isAddChartActive}
            availableCharts={availableCharts}
            handleAddChart={e => this.setState({ isAddChartActive: e })}
            updateAvailableChart={e => this.updateAvailableChart(e)}
          />
        )}
        {isShareModalActive && (
          <ShareReportModal
            show={isShareModalActive}
            isReportSending={isShareReportSending}
            shareReportStatus={this.props.shareReportStatus}
            sendReportFile={emailList => this.sendReport(emailList)}
            toggleShareReportModal={e => this.setState({ isShareModalActive: e })}
          />
        )}
        {isContactUs && (
          <ContactUs show={isContactUs} toggleModal={e => this.setState({ isContactUs: e })} />
        )}
      </div>
    );
  }
}

class RenderAvailableChart extends Component {
  removeChart = chartId => {
    ReactGA.event(
      {
        category : 'Chart' ,
        action : `user with user id ${this.props.cookies.cookies.userMeta} deleted chart with id ${chartId}`
      }
    )
    this.props.updateSelectedCharts([{ chartId, status: false }]);
  };
  render() {
    const { chart, dateFilterValue, selectedTopicId, source, filterBySentiments,isCommentsActive } = this.props;
    switch (chart.chartType) {
      case 'areaspline':
        return (
          <div className="chart-content trend">
            <i className="la la-times-circle" onClick={() => this.removeChart(chart.chartId)} />
            <AreaChart
              chartType={chart.chartType}
              title={chart.name}
              chartId={`chart${chart.chartId}`}
              selectedTopicId={[...selectedTopicId]}
              dateRangeFilterValue={dateFilterValue}
              source={[...source]}
              filterBySentiments={e => filterBySentiments(e)}
              isCommentsActive={isCommentsActive}
            />
          </div>
        );
      case 'line':
        return (
          <div className="chart-content trend">
            <i className="la la-times-circle" onClick={() => this.removeChart(chart.chartId)} />
            <LineChart
              chartType={chart.chartType}
              title={chart.name}
              chartId={`chart${chart.chartId}`}
              selectedTopicId={[...selectedTopicId]}
              source={[...source]}
              dateRangeFilterValue={dateFilterValue}
              filterBySentiments={e => filterBySentiments(e)}
              isCommentsActive={isCommentsActive}
            />
          </div>
        );
      case 'donut':
        return (
          <div className="chart-content">
            <i className="la la-times-circle" onClick={() => this.removeChart(chart.chartId)} />
            <PieChart
              title={chart.name}
              chartId={`chart${chart.chartId}`}
              selectedTopicId={[...selectedTopicId]}
              dateRangeFilterValue={dateFilterValue}
              source={[...source]}
            />
          </div>
        );
      case 'spider':
        return (
          <div className="chart-content">
            <i className="la la-times-circle" onClick={() => this.removeChart(chart.chartId)} />
            <SpiderChart
              title={chart.name}
              selectedTopicId={[...selectedTopicId]}
              chartId={`chart${chart.chartId}`}
              dateRangeFilterValue={dateFilterValue}
              source={[...source]}
            />
          </div>
        );
      case 'bar':
        return (
          <div className="chart-content">
            <i className="la la-times-circle" onClick={() => this.removeChart(chart.chartId)} />
            <BarChart
              title={chart.name}
              selectedTopicId={[...selectedTopicId]}
              chartId={`chart${chart.chartId}`}
              dateRangeFilterValue={dateFilterValue}
              source={[...source]}
            />
          </div>
        );
      case 'map':
        return (
          <div className="chart-content">
            <i className="la la-times-circle" onClick={() => this.removeChart(chart.chartId)} />
            <WorldMapChart
              title={chart.name}
              selectedTopicId={[...selectedTopicId]}
              chartId={`chart${chart.chartId}`}
              dateRangeFilterValue={dateFilterValue}
              source={[...source]}
            />
          </div>
        );
      case 'column':
        return (
          <div className="chart-content">
            <i className="la la-times-circle" onClick={() => this.removeChart(chart.chartId)} />
            <ColumnChart
              title={chart.name}
              selectedTopicId={[...selectedTopicId]}
              chartId={`chart${chart.chartId}`}
              dateRangeFilterValue={dateFilterValue}
              source={[...source]}
            />
          </div>
        );
      case 'sourcespercentcolumn':
        return (
          <div className="chart-content trend">
            <i className="la la-times-circle" onClick={() => this.removeChart(chart.chartId)} />
            <SourcesPercentColumnChart
              title={chart.name}
              selectedTopicId={[...selectedTopicId]}
              chartId={`chart${chart.chartId}`}
              dateRangeFilterValue={dateFilterValue}
              source={[...source]}
            />
          </div>
        );
      case 'wordcloud':
        return (
          <div className="chart-content">
            <i className="la la-times-circle" onClick={() => this.removeChart(chart.chartId)} />
            <WordCloud
              title={chart.name}
              selectedTopicId={[...selectedTopicId]}
              chartId={`chart${chart.chartId}`}
              dateRangeFilterValue={dateFilterValue}
              source={[...source]}
            />
          </div>
        );
      case 'sentiments':
        return (
          <div className="chart-emotions">
            <i
              className="la la-times-circle la-close"
              onClick={() => this.removeChart(chart.chartId)}
            />
            <SentimentsChart
              title={chart.name}
              selectedTopicId={[...selectedTopicId]}
              chartId={`chart${chart.chartId}`}
              dateRangeFilterValue={dateFilterValue}
              source={[...source]}
            />
          </div>
        );

      case 'emotions':
        return (
          <div className="row-emotions">
            <i
              className="la la-times-circle la-close"
              onClick={() => this.removeChart(chart.chartId)}
            />
            <EmotionsChart
              title={chart.name}
              selectedTopicId={[...selectedTopicId]}
              chartId={`chart${chart.chartId}`}
              dateRangeFilterValue={dateFilterValue}
              source={[...source]}
            />
          </div>
        );
      case 'bubble':
        return (
          <div className="chart-content bubble">
            <i className="la la-times-circle" onClick={() => this.removeChart(chart.chartId)} />
            <BubbleChart
              title={chart.name}
              chartId={`chart${chart.chartId}`}
              selectedTopicId={[...selectedTopicId]}
              dateRangeFilterValue={dateFilterValue}
              source={[...source]}
            />
          </div>
        );
      default:
        return <React.Fragment></React.Fragment>;
    }
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/features/home/components/Dashboard.js